<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- alert end -->
    <!-- Title-->
    <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()" />
    <!-- <HeaderComponent :headerTitle="headerText" /> -->
    <!-- popups  -->
    <v-row justify="center">
      <v-dialog v-model="approveRemarkPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Approve Tour Plan?</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="approveRemarkPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="text-center mt-5">
            <v-text-field v-model="add_remarks" color="primary" label="Add remarks ( if Any )" variant="outlined"></v-text-field>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="primary" class="mb-3 text-none" @click="approveRemarkPopup = false">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" @click="confirmApproveRequest">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- reject popup -->
    <v-row justify="center">
      <v-dialog v-model="rejectRemarkPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Reject Tour Plan?</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="rejectRemarkPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="text-center mt-5">
            <v-text-field v-model="reject_remarks" color="primary" label="Add remarks ( if Any )" variant="outlined"></v-text-field>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="primary" class="mb-3 text-none" @click="rejectRemarkPopup = false">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" @click="confirmRejectRequest">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="successPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ SuccessMessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" size="small" color="primary" class="mb-3 text-none" @click="closePopups">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
    <v-dialog v-model="visitDialog" persistent max-width="500px" style="height: 500px !important">
      <v-card class="v-card-100 mt-0">
         <v-card class="v-card-100 custom-shadow ma-0">
          <v-card-title class="pa-0">
          <v-row class="ma-1" style="font-weight: 600; font-size: 14px">            
            <span >{{ selectedVisit.dealer_name_1 }}</span>
            <v-spacer></v-spacer>
            <v-icon @click="visitDialog = false">mdi-close</v-icon>
            </v-row>
          </v-card-title>
         </v-card>
        <v-card-text class="pa-0">
          <v-row class="pa-0 ml-4 pr-4 pt-4">
            <v-col cols="6" class="pa-0">
              <span class="visit-info">Start Time</span>
            </v-col>
            <v-col cols="6" class="pa-0">
              <span class="visit-info">End Time</span>
            </v-col>            
          </v-row>
          <v-row class="pa-0 ml-4 pr-4 mb-3">
            <v-col cols="6" class="pa-0">
              <span><strong>{{selectedVisit.start_time ? convertToIST(selectedVisit.start_time) : '-' }}</strong> </span>
            </v-col>
            <v-col cols="6" class="pa-0">
              <span><strong>{{ selectedVisit.end_time ? convertToIST(selectedVisit.end_time) : '-' }}</strong> </span>
            </v-col>            
          </v-row>
          <v-row class="pa-0 ml-4 pr-4 mb-3">
            <v-col cols="6" class="pa-0">
              <span class="visit-info">Image</span>
            </v-col>
            <v-col cols="6" class="pa-0">
              <span class="visit-info">Cancelled Reason</span>
            </v-col>            
          </v-row>
          <v-row class="pa-0 ml-4 pr-4 mb-3">
            <v-col cols="6" class="pa-0">
              <span v-if="selectedVisit.cancel_images">
               <v-img
                  :src="selectedVisit.cancel_images"
                  height="50"
                  width="50"
                  cover
                  class="rounded"
                ></v-img></span>
              <span v-else>-</span>
            </v-col>
            <v-col cols="6" class="pa-0">
              <span><strong>{{ selectedVisit.cancel_remarks || '-' }}</strong> </span>
            </v-col>            
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-row>
    <!-- popups end -->
    <v-card-title style="padding: 20px 28px 0px 28px;" class="action-style mt-6" v-if="action === 'Approval Requests'">
      <!-- Search Fields -->
      <v-row>
        <v-col cols="2" sm="2">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="search_style" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="3" sm="3" class="p-0">
          <v-card-actions class="float-right">
            <v-btn class="mr-2 text-none" size="x-large" variant="outlined"  color="primary"  @click="rejectTourPlan">reject</v-btn>
            <v-btn class="mr-2 text-none" size="x-large" variant="flat"  color="primary" @click="approveTourPlan">Approve</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card class="v-card-100 mt-0">
      <v-card-text class="pl-0 pr-0 pt-0" v-if="!user.roles.includes('area_service_manager')">
        <v-row justify="space-around mt-1" style="border-top: 1px solid rgba(0, 0, 0, 0.3);border-bottom: 1px solid rgba(0, 0, 0, 0.3);">
          <v-col cols="2" class="d-flex flex-column text-left">
            <span class="summary_heading">Service Manager</span>
            <span class="summary_value">{{ managerDetails.sales_manager_name ? managerDetails.sales_manager_name: '-' }}</span>
          </v-col>
          <v-col cols="2" class="d-flex flex-column text-left">
            <span class="summary_heading">Service Manager ID</span>
            <span class="summary_value">{{ managerDetails.sales_manager_id ? managerDetails.sales_manager_id: '-' }}</span>
          </v-col>
          <v-col cols="2" class="d-flex flex-column text-left">
            <span class="summary_heading">From</span>
            <span class="summary_value">{{ managerDetails.tour_start_date ? DateFormat(managerDetails.tour_start_date).split('-').reverse().join('/'):'-' }}</span>
          </v-col>
          <v-col cols="2" class="d-flex flex-column text-left">
            <span class="summary_heading">To</span>
            <span class="summary_value">{{ managerDetails.tour_end_date ? DateFormat(managerDetails.tour_end_date).split('-').reverse().join('/'):'-' }}</span>
          </v-col>
        </v-row>
        <v-row justify="space-around" style="border-bottom: 1px solid rgba(0, 0, 0, 0.3);">
          <v-col cols="3" class="d-flex flex-column text-center">
            <span class="summary_subvalue">{{ managerDetails.total_sales_manager ? managerDetails.total_sales_manager: '-' }}</span>
            <span class="summary_subheading">Assigned Dealers</span>
          </v-col>
          <v-col cols="3" class="d-flex flex-column text-center">
            <span class="summary_subvalue">{{ managerDetails.total_planned_sales_manager ? managerDetails.total_planned_sales_manager: '-' }}</span>
            <span class="summary_subheading">Visit Planned</span>
          </v-col>
          <v-col cols="3" class="d-flex flex-column text-center">
            <span class="summary_subvalue">{{ managerDetails.total_unplanned_sales_manager ? managerDetails.total_unplanned_sales_manager: '-' }}</span>
            <span class="summary_subheading">Visit Not Planned</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="user.roles.includes('area_service_manager')" style="background-color: #EAF4FF;">
        <v-row>
          <v-col class="d-flex flex-column text-left">
            <span>ASM</span>
            <span class="text-bold">{{ user.first_name }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>ASM ID</span>
            <span class="text-bold">{{ user.user_id ? user.user_id : '-' }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>From</span>
            <span class="text-bold">{{ managerDetails.tour_start_date ? DateFormat(managerDetails.tour_start_date).split('-').reverse().join('/') : '-' }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>To</span>
            <span class="text-bold">{{ managerDetails.tour_end_date ? DateFormat(managerDetails.tour_end_date).split('-').reverse().join('/') : '-' }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column text-left">
            <span>Mapped Customer</span>
            <span class="text-bold">{{ managerDetails.total_sales_manager }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>Customer Planned</span>
            <span class="text-bold">{{ managerDetails.total_planned_sales_manager }}</span>
          </v-col>
          <v-col class="d-flex flex-column text-left">
            <span>Customer Not Planned</span>
            <span class="text-bold">{{ managerDetails.total_unplanned_sales_manager }}</span>
          </v-col>
          <v-col>
          </v-col>
        </v-row>
      </v-card-text>
    <!-- </v-card> -->
    <!-- <v-card class="v-card-100"> -->
      <v-layout column>
        <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
          <v-data-table hover
            density="compact"
            :search="search"
            v-model="selected"
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            fixed-header
            :height="minTableHeight" 
            :loading="loading"
            :items-per-page="table_data.length"
            return-object
            loading-text="Loading Data... Please wait"
            class="elevation-1" >
            <template v-for="header in headers" :key="header.key" v-slot:[`item.${header.key}`]="{ item }">
              <v-span v-if="(header.key != 'visit_date' && header.key == 'dealer_name_1') && ( action == 'Approved Tour Plans' || action == 'History')"
                @click="openVisitDialog(item)" 
                :class="[
                  'cursor-pointer',
                  check_visited_sales_manager[`${item.visit_date}_${header.key}`] == 'Visited' ? 'text-green' : 
                  check_visited_sales_manager[`${item.visit_date}_${header.key}`] == 'Not Visited' ? 'text-red' : '']"
                  style="text-decoration: underline;"
                  >
                {{ item[`${header.key}`] ? item[`${header.key}`] : '-' }}
              </v-span>
              <v-span v-else-if="header.key === 'visit_date'">
                {{ item.visit_date && item.visit_date != "null"  ? DateFormat(item.visit_date).split('-').reverse().join('/') : '-'}}
              </v-span>
              <v-span v-else-if="header.key === 'visitDate'">
                {{ item.visitDate && item.visitDate != "null"  ? DateFormat(item.visitDate).split('-').reverse().join('/') : '-'}}
              </v-span>
              <v-span v-else-if="header.key === 'address'">
                {{ item.address && item.address.address_detail ? item.address.address_detail : '-' }}
              </v-span>
              <v-span v-else-if="header.key === 'location'">
                {{ item.location && item.location[0].address_detail ? item.location[0].address_detail : '-' }}
              </v-span>
              <v-span v-else-if="header.key === 'customer_name'">
                {{ item.customer_name && item.customer_name.cutomer_name ? item.customer_name.cutomer_name : '-' }}
              </v-span>
              <v-span v-else>
                {{ item[`${header.key}`] ? item[`${header.key}`] : '-' }}
              </v-span>
            </template>
            <!-- <template v-slot:item.customer_name="{ item }">
              {{ item.customer_name && item.customer_name != "null"  ? item.customer_name.cutomer_name : '-'}}
            </template>
            <template v-slot:item.location="{ item }">
              {{ item.location && item.location != "null"  ? item.location.map(loc => loc.address_detail).join("\n  ") : '-'}}
            </template>
            <template v-slot:item.address="{ item }">
              {{ item.address && item.address != "null"  ? item.address.address_detail : '-'}}
            </template>
            <template v-slot:item.customer_dealer_name="{ item }">
              <span :class="!checkPastDate(item.visit_date) ? 'grey_color' : item.customer_visited && !checkPastDate(item.visit_date) ? 'text-green' : 'text-red'">{{ item.customer_dealer_name ? item.customer_dealer_name : '-' }}</span>
            </template> -->
            <!-- <template v-slot:item.sales_manager_2="{ item }">
              <v-span :class="check_visited_sales_manager[`${item.visit_date}_sales_manager_2`] == 'Visited' ? 'text-green' : check_visited_sales_manager[`${item.visit_date}_sales_manager_2`] == 'Not Visited' ? 'text-red' : ''">
                {{ item.sales_manager_2 }}
              </v-span>
            </template>
            <template v-slot:item.sales_manager_3="{ item }">
              <v-span :class="check_visited_sales_manager[`${item.visit_date}_sales_manager_3`] == 'Visited' ? 'text-green' : check_visited_sales_manager[`${item.visit_date}_sales_manager_3`] == 'Not Visited' ? 'text-red' : ''">
                {{ item.sales_manager_3 }}
              </v-span>
            </template> -->
            <template #bottom></template>
          </v-data-table> 
        </v-col>
      </v-layout>
      <v-card-actions class="float-right" v-if="action === 'Create Tour Plan'">
        <v-btn class="mb-8 text-none" variant="flat" color="primary" outlined @click="editItems">Edit</v-btn>
        <v-btn class="mb-8 text-none" variant="flat" color="primary" :disabled="number > 0" @click="createTourPlan">Continue</v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>
<script>
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue'
  export default {
    components: {
      HeaderComponent,
    },
    data() {
      return {
        headerText: "Tour Plan",
        alert: false,
        alert_type: "success",
        alert_message: '',
        selected: [],
        table_data : [],
        managerDetails: [],
        search: '',
        loading: false,
        search_tag: '',
        headers: [
          { title: "Date", key: "visit_date" },
          { title: "Service Manager 1", key: "manager_customer_name" },
          { title: "Service Manager 2", key: "assigned_partner" },
          { title: "Service Manager 3", key: "assigned_partner" },
        ],
        approveRemarkPopup: false,
        rejectRemarkPopup: false,
        successPopup: false,
        reject_remarks: '',
        add_remarks: '',
        SuccessMessage: '',
        original_sales_manager : '',
        check_visited_sales_manager : {},
        planned_manager_count : '',
        totat_sales_manager_count : '',
        sales_manager_mapping : {},
        dealer_sales_key : 'Service Manager',
        number : 0,
        minTableHeight: '',
        visitDialog: false,
        selectedVisit: {},
      }
    },
    mounted() {
      this.calculateTableHeight();
      window.addEventListener('resize', this.calculateTableHeight);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.calculateTableHeight);
    },
    async created() {
      this.user = this.$store.state.currentUser
      this.tour_id = this.$store.state.lotIds
      this.action = this.$store.state.tour_action ? this.$store.state.tour_action : this.$store.state.action 
      this.itemsID = this.$store.state.inventoryId
      this.get_fromDate = this.$store.state.from_Date
      this.get_toDate = this.$store.state.to_date
      this.get_details = this.$store.state.select_details
      this.get_manager= this.$store.state.manager_details
      this.planned_manager_count = this.$store.state.total_planned_manager
      this.totat_sales_manager_count = this.$store.state.total_sales_manager
      if (this.action === "Create Tour Plan"){
        // this.table_data = this.get_manager 
        if(this.user.roles.includes('area_service_manager')){
          this.original_sales_manager = this.$store.state.original_sales_manager
          this.update_headers_table_date(this.get_manager)
          this.managerDetails = {
            tour_start_date: this.get_fromDate,
            tour_end_date: this.get_toDate,
            details: '',
            manager: '',
            sales_manager_name : '',
            sales_manager_id : '',
            total_sales_manager : this.totat_sales_manager_count,
            total_planned_sales_manager: this.planned_manager_count,
            total_unplanned_sales_manager: this.totat_sales_manager_count - this.planned_manager_count,
          };
        } else {
          this.update_headers_table_date(this.get_manager)
          this.original_sales_manager = this.$store.state.original_sales_manager
          this.managerDetails = {
            tour_start_date: this.get_fromDate,
            tour_end_date: this.get_toDate,
            details: this.get_details,
            manager: this.get_manager,
            sales_manager_name : this.user.first_name,
            sales_manager_id : this.$store.state.service_manager_id,
            total_sales_manager : this.totat_sales_manager_count,
            total_planned_sales_manager: this.planned_manager_count,
            total_unplanned_sales_manager: this.totat_sales_manager_count - this.planned_manager_count,
          };
        }
      }else if(this.action === 'Pending Approval' && this.user.roles.includes('area_service_manager')){
        this.headers = [
          { title: 'Date', key: 'visit_date'},
          { title: 'Type of Vendor', key: 'type_of_vendor'},
          { title: 'Vendor Name', key: 'dealer_name'},
          { title: 'Location', key: 'address'}
        ]
        // this.original_sales_manager = this.table_data = this.$store.state.original_sales_manager
        
        this.loading = true;
        this.$httpSecured.get(`/api/v1/warehouse/fta/tour_plan/tours/${this.itemsID}`)
          .then(response => {
            if (response.data && response.data['fta/tour_plan/tour']) {
              this.table_data = response.data['fta/tour_plan/tour'].list_of_visit;
              this.managerDetails = {
                tour_start_date: response.data['fta/tour_plan/tour'].tour_start_date,
                tour_end_date: response.data['fta/tour_plan/tour'].tour_end_date,
                details: '',
                manager: '',
                sales_manager_name : '',
                sales_manager_id : '',
                total_sales_manager : response.data['fta/tour_plan/tour'].total_sales_manager,
                total_planned_sales_manager: response.data['fta/tour_plan/tour'].total_planned_sales_manager,
                total_unplanned_sales_manager: response.data['fta/tour_plan/tour'].total_unplanned_sales_manager,
              };
              this.loading = false;
            } else {
              this.showAlert('error', 'No Data Found');
              this.number = 0;
            }
          })
          .catch(error => {
            this.number = 0;
            this.loading = false;
            this.errorMessagePopup = true;
            this.showAlert("error", error.response.data.message);
          });
      }else {
        if(this.user.roles.includes('area_service_manager'))
          this.headers = [
            { title: 'Date', key: 'visit_date' },
            { title: 'Type of Vendor', key: 'type_of_vendor' },
            { title: 'Customer Name', key: 'customer_dealer_name'},
            { title: 'Customer Entity Address', key: 'address'}
          ]
        this.showTourPlan();
      }
    },
    methods: {
      openVisitDialog(visitData) {
        console.log(JSON.stringify(visitData))
        if (!visitData || typeof visitData !== 'object') return;
        this.selectedVisit = visitData;
        this.visitDialog = true;
      },
      calculateTableHeight() {
        const viewportHeight = window.innerHeight;
        const additionalSpace = 400;
        const maxTableHeight = viewportHeight - additionalSpace;    
        this.minTableHeight = maxTableHeight + 'px';
      },
      showTourPlan(){
        this.loading = true;
        let id;
        if(this.action === "Upcoming Visits"){
          id = this.tour_id
        }else{
          id = this.itemsID
        }
        this.$httpSecured.get(`/api/v1/warehouse/fta/tour_plan/tours/${id}`)
          .then(response => {
            if (response.data && response.data['fta/tour_plan/tour']) {
              this.managerDetails = response.data['fta/tour_plan/tour'];
              const listOfVisit = response.data['fta/tour_plan/tour'].list_of_visit;
              if(this.user.roles.includes('area_service_manager'))
                this.update_table_for_service_manager(listOfVisit)
              else this.update_headers_table_date(listOfVisit)
              this.loading = false;
            } else {
              this.showAlert('error', 'No Data Found');
              this.number = 0;
            }
          })
          .catch(error => {
            this.number = 0;
            this.loading = false;
            this.errorMessagePopup = true;
            this.showAlert("error", error.response.data.message);
          });
      },
       update_table_for_service_manager(listOfVisit){
        this.table_data = []
        listOfVisit.forEach(visit => {
          this.table_data.push({
            'visit_date' : visit.visit_date,
            'type_of_vendor' : visit.type_of_vendor,
            'customer_dealer_name' : `${visit.manager_customer_name} (${visit.customer_dealer_code})`,
            'address' : visit.address.address_detail,
            'customer_visited' : visit.is_visited
          })
        })
      },
      update_headers_table_date(listOfVisit) {
          if (!Array.isArray(listOfVisit) || listOfVisit.length === 0) {
              console.error("listOfVisit is not defined or is empty.");
              return;
          }

          const groupedVisits = {};
          let sales_manager_count = 0;
          let key, dealer_type;

          if ('dealer_name' in listOfVisit[0] && listOfVisit[0]['dealer_name']) {
              key = 'dealer_name';
              this.dealer_sales_key = dealer_type = 'Visits';
          } else {
              key = 'sales_manager';
              dealer_type = 'Service Manager';
          }

          listOfVisit.forEach(visit => {
              if (!groupedVisits[visit.visit_date]) {
                  groupedVisits[visit.visit_date] = [];
              }
              if (this.action === "Create Tour Plan") {
                  groupedVisits[visit.visit_date].push({
                      name: key === 'dealer_name' ? `${visit[key]} (${visit.customer_dealer_code})` : visit[key],
                      is_visited: visit.is_visited,
                      role: visit.manager_level,
                      start_time: visit.start_time,
                      end_time: visit.end_time,
                      cancel_images: visit.cancel_images,
                      cancel_remarks: visit.cancel_remarks
                  });
              } else {
                  groupedVisits[visit.visit_date].push({
                      name: key === 'dealer_name' ? `${visit[key]} (${visit.customer_dealer_code})` : `${visit[key]} (${visit.sales_manager_user_id})`,
                      is_visited: visit.is_visited,
                      role: visit.manager_level,
                      start_time: visit.start_time,
                      end_time: visit.end_time,
                      cancel_images: visit.cancel_images,
                      cancel_remarks: visit.cancel_remarks
                  });
              }
              sales_manager_count = Math.max(sales_manager_count, groupedVisits[visit.visit_date].length);
          });

          const headers = [{ title: 'Date', key: 'visit_date' }];
          for (let ind = 0; ind < sales_manager_count; ind++) {
              headers.push({ title: `${dealer_type}`, key: `${key}_${ind + 1}` });
          }

          const tableData = [];
          Object.keys(groupedVisits).forEach(date => {
              const rowData = { visit_date: date };
              groupedVisits[date].forEach((manager, index) => {
                  const today_date = new Date();
                  today_date.setHours(0, 0, 0, 0);
                  const original_date = new Date(date);
                  original_date.setHours(0, 0, 0, 0);
                  rowData['start_time'] = manager.start_time;
                  rowData['end_time'] = manager.end_time;
                  rowData['cancel_images'] = manager.cancel_images;
                  rowData['cancel_remarks'] = manager.cancel_remarks;

                  if (manager) {
                      rowData[`${key}_${index + 1}`] = manager.name;
                      this.check_visited_sales_manager[`${date}_${key}_${index + 1}`] = 
                          (original_date <= today_date) 
                              ? (manager.is_visited ? 'Visited' : 'Not Visited') 
                              : 'NA';
                  }
              });
              tableData.push(rowData);
          });

          this.headers = headers;
          tableData.sort((a, b) => {
              const dateA = new Date(a.visit_date);
              const dateB = new Date(b.visit_date);
              return dateA - dateB;
          });
          this.table_data = tableData;
          console.log(this.table_data);
          console.log(this.headers);
      },
      editItems() { 
        var managerDetails = ''
        if(!this.user.roles.includes('area_service_manager')){
          managerDetails = this.get_manager.map(manager => ({
            date: manager.visit_date,
            sales_manager : manager.manager_customer_name
          }));
        }
          this.$store.commit("tourVisits", {
            from_Date : this.get_fromDate,
            to_date : this.get_toDate,
            select_details : this.get_details,
            manager_details : managerDetails,
            tour_action: "Create Tour Plan",
            method : true,
            original_sales_manager : this.original_sales_manager,
            total_sales_manager : '',
            total_planned_manager : '',
            service_manager_id : ''
          });
        if (this.get_details === 'sales_manager_wise') {
          this.$router.push({ name: "tourVisit"});
        }
        if(this.get_details === 'date_wise') {
          this.$router.push({ name: "tourVisit"});
        }
      },
      createTourPlan(){
        this.number++;
        const totalManager = this.totat_sales_manager_count
        const plannedManager = this.planned_manager_count
        const unplannedManager = this.totat_sales_manager_count - this.planned_manager_count
        var params;
        if(this.user.roles.includes('area_service_manager')){
          const visitSummary = []
          this.get_manager.forEach(manager => {
            const address_hash = {}
            address_hash[manager.cutomer_id] = [manager.location_id ? manager.location_id : null]
            visitSummary.push({
                  "date": manager.visit_date,
                  "customers": [manager.cutomer_id],
                  "address_hash" : address_hash
              });
          });
          params = {
            "tour_start_date": this.get_fromDate,
            "tour_end_date": this.get_toDate,
            "tour_method": "customer_wise",
            "sales_manager_name": this.user.first_name,
            "sales_manager_id": this.user.id,
            "tour_plan_summary": {
              "total_sales_manager": totalManager,
              "total_planned_sales_manager": plannedManager,         
              "total_unplanned_sales_manager": unplannedManager,
              "visit_summary": visitSummary
            }
          };
      } else {

        const visitSummaries = [];
        if (this.get_details === 'sales_manager_wise') {
          this.get_manager.forEach(manager => {
            visitSummaries.push({
                "date": manager.visit_date,
                "sales_managers": [manager.salesManagerID]
            });
        });
        }
        if (this.get_details === 'date_wise') {
          this.get_manager.forEach(manager => {
              visitSummaries.push({
                  "date": manager.visit_date,
                  "sales_managers": [manager.salesManagerID]
              });
          });
        }
        const filteredVisitSummaries = visitSummaries.filter(summary => summary.date && summary.sales_managers.length > 0);
        params = {
            "tour_start_date": this.get_fromDate,
            "tour_end_date": this.get_toDate,
            "tour_method": this.get_details,
            "sales_manager_name": this.user.first_name,
            "sales_manager_id": this.user.id,
            "tour_plan_summary": {
              "total_sales_manager": totalManager,
              "total_planned_sales_manager": plannedManager,         
              "total_unplanned_sales_manager": unplannedManager,
              "visit_summary": filteredVisitSummaries
            }
          };
      }
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/create_tour_plans', params)
        .then(response => {
          if (response.data) {
            this.SuccessMessage = response.data.message;
            this.successPopup = true;
            this.loading = false
            this.number = 0;
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.showAlert("error",error.response.data.message) 
        });
      },
      getRouterLink() {
        this.$store.commit("setLotIds", {
            lotIds: this.$store.state.lotIds,
            inventoryId:  this.$store.state.inventoryId,
            action:this.action,
        })
        if (this.action === "Pending Approval" || this.action === "Approval Requests" || this.action === "Approved Tour Plans" || this.action === "History" || this.action === "Upcoming Visits") {
          return { name: "tourVisit" };
        }
      },
      getRouterLinkText() {
        if (this.action !== "Create Tour Plan"){
          return this.action;
        }
      },
      componentsName() {
        if (this.action === "Pending Approval" || this.action === "Approval Requests" || this.action === "Approved Tour Plans" || this.action === "History") {
          return this.tour_id;
        }else if(this.action === "Upcoming Visits"){
          return this.itemsID
        }
      },
      approveTourPlan(){
        this.approveRemarkPopup = true
      },
      rejectTourPlan(){
        this.rejectRemarkPopup = true
      },
      confirmApproveRequest(){
        const item_id = this.itemsID
        this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/take_action', {
          "ids": item_id,
          "status": "approved",
          "remarks": this.add_remarks,
        },)
          .then(response => {
            if (response.data) {
              this.SuccessMessage = response.data.message;
              this.successPopup = true;
              this.rejectRemarkPopup = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.message);
            this.number = 0;
            this.loading = false;
            this.rejectRemarkPopup = false;
          });
      },
      confirmRejectRequest(){
        const item_id = this.itemsID
        this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/take_action', {
          "ids": item_id,
          "status": "rejected",
          "remarks": this.reject_remarks,
        },)
          .then(response => {
            if (response.data) {
              this.SuccessMessage = response.data.message;
              this.successPopup = true;
              this.rejectRemarkPopup = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.message);
            this.number = 0;
            this.loading = false;
            this.rejectRemarkPopup = false;
          });
      },
      closePopups(){
        this.successPopup = false
        this.approveRemarkPopup = false
        this.rejectRemarkPopup = false
        this.$store.commit("tourVisits", { tour_action: "Close" });
        this.$router.push({ name: "tourVisit"})
      },
      checkPastDate(date){
        const org_date = new Date(date)
        const today_date = new Date()
        org_date.setHours(0,0,0,0)
        today_date.setHours(0,0,0,0)
        return org_date <= today_date
      }, 
      showAlert(alert_type, alert_message) {
        this.scrollToTop();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      DateFormat(date){
        const new_date = new Date(date ? date : new Date());
        const dd = String(new_date.getDate()).padStart(2, '0');
        const mm = String(new_date.getMonth() + 1).padStart(2, '0');
        const yyyy = new_date.getFullYear();
        return `${yyyy}-${mm}-${dd}`
      },
      convertToIST(dateString) {
        const options = {
          timeZone: 'Asia/Kolkata',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        };

        const date = new Date(dateString);
        const formatter = new Intl.DateTimeFormat('en-GB', options);
        const parts = formatter.formatToParts(date);

        const datePart = `${parts.find(p => p.type === 'day').value}-${parts.find(p => p.type === 'month').value}-${parts.find(p => p.type === 'year').value}`;
        const timePart = `${parts.find(p => p.type === 'hour').value}:${parts.find(p => p.type === 'minute').value}`;

        return `${timePart}`;
      }
    },
  }
</script>
<style>
  .table-margin {
    border-bottom: 1px solid #ccc;
  }
  .t-head{
    padding: 12px 0px 12px 25px;
  }
  .text-bold {
    font-size: 14;
    font-weight: 600;
    line-height: 16.94px;
  }
  .text-green {
      color: green;
    }

    .text-red {
      color: red;
    }
    .grey_color{
    color: grey;
  }
    .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 340px) !important;
  }
  .summary_heading{
    color: #5A5A5A;
    font-size: 14px;
    font-weight: 600;
    line-height: 100%;
  }
  .summary_value{
    color: #0C0C0C;
    font-size: 14px;
    font-weight: 600;
    line-height: 100%;
  }
  .summary_subvalue{
    color: #1A1B35;
    font-size: 16px;
    font-weight: 700;
    line-height: 140%;
  }
  .summary_subheading{
    color: #1A1B35;
    font-size: 12px;
    font-weight: 500;
    line-height: 140%;
  }
  .visit-info{
    font-size: 14px;
    font-weight: 500;
    color: #938989;
  }
</style>